import { render, staticRenderFns } from "./Newsletters.vue?vue&type=template&id=9c4ef0b0&scoped=true&"
import script from "./Newsletters.vue?vue&type=script&lang=js&"
export * from "./Newsletters.vue?vue&type=script&lang=js&"
import style0 from "./Newsletters.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Newsletters.vue?vue&type=style&index=1&id=9c4ef0b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c4ef0b0",
  null
  
)

component.options.__file = "Newsletters.vue"
export default component.exports